module.exports = __webpack_public_path__ + "media/images/university_logos/Manchester-Metropolitan-University-a84fdeea956c9cd09aa313f097a31bc3.svg";